import type { Job } from "../types";

export const experience: readonly Job[] = [
  {
    role: "Senior Ruby / RoR Engineer",
    company: "NinjaHoldings (CreditNinja)",
    iconSrc: "/companies/ninjaholdings.png",
    period: "2021 — Present",
    meta: "Full-time",
    location: "Remote",
    summary:
      "Designing and shipping the decision engine and platform integrations for a US consumer lending product. Stack: Ruby on Rails, Postgres, Redis, RSpec.",
    bullets: [
      "Redesigned and rewrote the Decision Engine — better performance, error handling, and analytics.",
      "Built a reports_manager gem that aggregates and caches credit-bureau reports across sources, reducing pull costs.",
      "Integrated risk models, credit bureaus, lead-buyer platforms, and a SOAP-based loan management system.",
      "Bank-accounts aggregator integration.",
      "Authored and implemented Technical Design Documents (TDDs).",
    ],
    highlight: true,
  },
  {
    role: "Software Engineer",
    company: "Airbnb",
    iconSrc: "/companies/airbnb.png",
    period: "2019 — 2021",
    meta: "Full-time · 2 yrs 2 mos",
    location: "Kyiv, Ukraine\nVancouver, Canada",
    summary:
      "Cross-stack product engineering — backend, frontend, migrations, and mentoring — in close collaboration with product owners and designers.",
    bullets: [
      "Migrated existing React projects from JavaScript to TypeScript.",
      "Built new features with React / Redux / TypeScript; tested with Jest, Cypress, and testing-library.",
      "Migrated a legacy monolith to microservices.",
      "Backend feature development with Rails + RSpec using TDD.",
      "Code reviews, technical interviews, and documentation.",
    ],
  },
  {
    role: "Software Engineer",
    company: "Faster Than Light",
    iconSrc: "/companies/ftl.png",
    period: "Mar — Jul 2019",
    meta: "Full-time · 5 mos",
    location: "Kyiv, Ukraine",
    summary:
      "Set up project architecture and shipped features end-to-end with Rails, GraphQL, React, and PostgreSQL.",
    bullets: [
      "Defined specifications working directly with the customer and UI designer.",
      "Architected the project — Rails, GraphQL, React, Postgres.",
      "Tested with RSpec, Jest, Chai, Mocha.",
      "Mentored junior and mid-level developers across specs, implementation, and reviews.",
    ],
  },
  {
    role: "Ruby on Rails Engineer",
    company: "Ciklum",
    iconSrc: "/companies/ciklum.png",
    period: "Jan — Nov 2018",
    meta: "11 mos",
    location: "Kyiv, Ukraine",
    summary:
      "Supported a Rails 2.x legacy app while splitting it into Rails 5.x + Python microservices and migrating the frontend off Backbone.",
    bullets: [
      "Split legacy Rails 2.x monolith into Rails 5.x and Python microservices.",
      "Frontend migration from Backbone to React + Redux.",
      "Used AWS Lambda for face recognition and image transformation.",
      "Test coverage with RSpec.",
    ],
  },
  {
    role: "Ruby on Rails Engineer",
    company: "NCube",
    iconSrc: "/companies/ncube.png",
    period: "Apr 2017 — Jan 2018",
    meta: "Full-time · 10 mos",
    location: "Kyiv, Ukraine",
    summary:
      "Maintained and extended a Rails 3.x application in collaboration with a Belgian team, including SSO migration and microservice extraction.",
    bullets: [
      "Maintained existing Rails 3.x code and shipped new features.",
      "Moved application authentication to SSO.",
      "Split the application into microservices.",
      "Built and supported a Chrome extension.",
    ],
  },
  {
    role: "Ruby Engineer",
    company: "SoftServe",
    iconSrc: "/companies/softserve.png",
    period: "Aug 2016 — Mar 2017",
    meta: "8 mos",
    location: "Lviv, Ukraine",
    summary:
      "Built and maintained a Rails 4.x + Angular 1 product with a Texas-based team.",
    bullets: [
      "Frontend with Angular 1.x and Charts.js.",
      "RDBMS: Vertica. Full-text search with Elasticsearch.",
      "Background jobs with Resque and Sidekiq.",
      "Tested with RSpec, Cucumber, Capybara, Jasmine.",
      "Authored technical documentation.",
    ],
  },
  {
    role: "Ruby on Rails Engineer",
    company: "MEV, LLC",
    iconSrc: "/companies/mev.png",
    period: "Jan — Jun 2016",
    meta: "6 mos",
    location: "Cherkasy, Ukraine",
    summary:
      "Rails + Backbone development with third-party SOAP integrations and Stripe-based subscriptions.",
    bullets: [
      "Implemented subscriptions and payments with Stripe.",
      "Integrated third-party SOAP APIs.",
      "Migrated codebase from Rails 3.x to 4.x.",
    ],
  },
  {
    role: "Ruby on Rails Engineer",
    company: "Active Bridge",
    iconSrc: "/companies/active_bridge.png",
    period: "Apr 2015 — Jan 2016",
    meta: "10 mos",
    location: "Cherkasy, Ukraine",
    summary:
      "Started my career building Rails 3.x backend features and Angular 1.x / jQuery frontends with a local team.",
    bullets: [
      "Backend features and maintenance with Rails 3.x.",
      "Frontend with jQuery and Angular 1.x.",
      "RSpec coverage and test discipline.",
    ],
  },
];
